import { render, staticRenderFns } from "./SouthbayAmenities.vue?vue&type=template&id=74fe3099&"
import script from "./SouthbayAmenities.vue?vue&type=script&lang=js&"
export * from "./SouthbayAmenities.vue?vue&type=script&lang=js&"
import style0 from "./SouthbayAmenities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports